<template>
  <div class="mdl-card mdl-shadow--2dp">
    <div
      class="mdl-card__title unanswered"
      style="background: linear-gradient(to bottom,  rgba(0, 0, 0, 0) 0%, #04afb9 160%), url('../../../../static/assets/emptyprophygroup.jpg') center / cover">
      <h2 class="mdl-card__title-text">
        Trend Comparisons
      </h2>
    </div>

    <div
      class="ui top right attached label"
      style="background-color: rgba(38, 61, 75, 0.7); color: white; text-shadow: none;">
      BETA
    </div>

    <div class="mdl-card__supporting-text">
      <p v-if="totalStudiesAvailable > 0">
        Track and compare your progress with other users on the same preventive treatments:
      </p>
      <p v-else>
        No treatments currently available.
      </p>
    </div>

    <div
      v-for="(value, key) in availableInternalStudies"
      v-if="value.studies.length > 0"
      :key="key"
      class="mdl-card__actions mdl-card--border category">

      <div
        class="ui fluid big tertiary right labeled icon button category-button"
        @click="value.display = !value.display">
        {{ key }}
        <i
          :class="{ plus: !value.display, minus: value.display }"
          class="icon"/>
      </div>

      <transition name="fade" mode="out-in">
        <div
          v-if="value.display"
          key="open"
          class="category-container">
          <router-link
            tag="div"
            class="option-container"
            v-for="option in value.studies"
            :key="option.header"
            :to="{ name: 'Questionnaire', params: { formId: option.baselineFormId }, query: { study: option.studyName, country: userCountry, lang: userLang, uid: userId, prophy: option.molecule, 'recurring_order': 0} }">
            <div class="option-header">
              {{ option.header }}<br>
              <small>{{ option.subheader }}</small>
            </div>
            <div class="option-button">
              <i class="right chevron icon"/>
            </div>
          </router-link>
        </div>

        <div
          v-else
          key="close"
          class="category-label ui inverted left labeled icon label">
          <i class="clone outline icon"/>
          {{ value.studies.length }} treatment<span v-if="value.studies.length !== 1">s</span> available in this category
        </div>
      </transition>

    </div>
    <div class="mdl-card__supporting-text" style="margin-top: 0;">
        <p>As this is still in BETA, more treatments would be added later. If you have feedback, please let us know at <a href="mailto:jenny@healint.com" class="primary-text"><u>jenny@healint.com</u></a></p>
      </div>
  </div>
</template>

<script>
//

import { mapState } from 'vuex'
export default {
  name: 'JoinGroupCard',
  props: {
    optionsList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      availableInternalStudies: {
        Medication: {
          display: true,
          studies: []
        },
        Lifestyle: {
          display: true,
          studies: []
        },
        Others: {
          display: true,
          studies: []
        }
      }
    }
  },
  computed: {
    ...mapState(['recurringStudies']),
    totalStudiesAvailable: function () {
      let total = 0
      for (let i in this.availableInternalStudies) {
        total += this.availableInternalStudies[i].studies.length
      }
      return total
    }
  },
  mounted () {
    let enrolledStudies = this.optionsList.map(o => o.study)

    for (let i in this.recurringStudies) {
      let study = this.recurringStudies[i]
      if (study.canJoin === true && !enrolledStudies.includes(study)) {
        if (this.availableInternalStudies.hasOwnProperty(study.category)) {
          this.availableInternalStudies[study.category].studies.push(study)
        } else {
          this.availableInternalStudies.Others.studies.push(study)
        }
      }
    }
  }
}
</script>

<style scoped>

.category {
  padding: 12px 10px;
}

.category-button {
  border-radius: .28571429rem .28571429rem 0 0;
}

.category-container, .category-label {
  width: 100%;
  background-color: rgb(38, 61, 75);
  margin: 0;
  border-radius: 0 0.28571429rem .28571429rem;
}

.category-container {
  padding: 14px;
}

.option-container {
  border-radius: 2rem;
  background-color: #446a83;
  box-shadow: 1px 2px 2px rgba(0,0,0,0.3);
  margin-bottom: 14px;
  display: flex;
  justify-content: space-between;
}

.option-header {
  display: block;
  padding: 10px 0 8px 2.1rem;
  line-height: 1.2rem;
  font-size: 1.25rem;
}

.option-header small {
  font-size: 0.84rem;
  font-style: italic;
}

.option-button {
  background-color: #446a83;
  border-radius: 0 2rem 2rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.option-button i {
  margin: 0 12px 0 12px;
  color: white;
}

.option-container:last-child {
  margin-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/survey/recurring/FancyJoinGroupCard.vue